import ModalViewModel from 'infra/ModalViewModelSansDecorators'
import { action, computed, makeObservable, observable } from 'mobx'
import { Id } from 'types/definitions'
import BookkeepingProgressionStore from 'jobs/bookkeeping/BookkeepingProgressionStore'
import { BookkeepingCycle } from 'jobs/bookkeeping/BookkeepingProgressionInfo'
import { isNotNil } from 'utils/object-util'

export interface CompletedWorkItem {
  name: string
  quantity: number
}

export default class BookkeepingCycleDetailsViewModel extends ModalViewModel {
  cycle: BookkeepingCycle = BookkeepingCycle.none

  constructor(
    private jobId: Id,
    private bookkeepingProgressionStore: BookkeepingProgressionStore,
  ) {
    super()
    makeObservable(this, {
      cycle: observable,
      bookkeepingProgressionInfo: computed,
      selectedCycleNumber: computed,
      completedWorkItemsInCycle: computed,
      open: action.bound,
    })
  }

  /**
   * Returns the bookkeeping progression info.
   */
  get bookkeepingProgressionInfo() {
    return this.bookkeepingProgressionStore.bookkeepingProgressions.get(
      this.jobId,
    )
  }

  /**
   * Returns the selected bookkeeping cycle number.
   * @returns the cycle number.
   */
  get selectedCycleNumber(): number {
    return this.cycle.number
  }

  /**
   * Returns a list of bookkeeping completed work items in a cycle.
   * @returns an array of `CompletedWorkItem`
   */
  get completedWorkItemsInCycle(): CompletedWorkItem[] {
    return (this.bookkeepingProgressionInfo?.workItems || [])
      .map((workItem) => {
        const completeItem = (this.cycle.workItemsCompletion || []).find(
          (ci) => ci.id === workItem.workItemId,
        )

        if (!completeItem) {
          return null
        }

        return {
          name: completeItem.name,
          quantity: completeItem.completedCount,
        }
      })
      .filter(isNotNil)
  }

  /**
   * Sets the cycle to be selected and shows the dialog.
   * @param selectedCycle
   */
  open(selectedCycle: BookkeepingCycle) {
    this.cycle = selectedCycle
    this.show()
  }
}
